import * as React from "react";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import { makeStyles } from "@material-ui/styles";
import Typography from "@mui/material/Typography";

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: "100%",
    height: "60%",
    margin: 0,
  },
  listBox: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    border: "1px solid #4DD0E1",
    borderRadius: "3px",
  },
  header: {
    padding: theme.spacing(1),
    display: "flex",
    backgroundColor: "#f5f5f5",
    borderBottom: "1px solid #e0e0e0",
  },
  headerItem: {
    margin: "0 10px",
  },
  listContainer: {
    flexGrow: 1,
    overflowY: "auto",
  },
}));

export default function DropdownList({
  supplierList,
  setCompanynumber,
  setCompanyname,
  setCompanynamefull,
}) {
  const classes = useStyles();
  const [supplierName, setSupplierName] = React.useState([]);
  const handleToggle = (value) => {
    const currentIndex = supplierName.indexOf(value[0]);

    setSupplierName(value[0]);
    console.log(value);
    if (value[0].includes("エラー")) {
      setCompanynumber("");
      setCompanyname("");
      setCompanynamefull("");
    } else {
      setCompanynumber(Number(value[0]));
      setCompanyname(value[1]);
      setCompanynamefull(value[2]);
    }
  };

  return (
    <FormControl className={classes.formControl}>
      <div className={classes.listBox}>
        {/* Header */}
        <div className={classes.header}>
          <div className={classes.headerItem}>
            <Typography variant="subtitle1">会社番号</Typography>
          </div>
          <div className={classes.headerItem}>
            <Typography variant="subtitle1">会社名</Typography>
          </div>
        </div>
        <List className={classes.listContainer}>
          {supplierList.map((supplier) => {
            const labelId = `checkbox-list-label-${supplier[0]}`;
            //const supplierValue = supplier.join(',');
            //console.log("supplierValue", supplier);
            return (
              <ListItem
                key={supplier[0]}
                role={undefined}
                dense
                button
                onClick={() => handleToggle(supplier)}
              >
                {
                  <Checkbox
                    edge="start"
                    checked={supplierName.indexOf(supplier[0]) !== -1}
                    tabIndex={-1}
                    disableRipple
                    inputProps={{ "aria-labelledby": labelId }}
                  />
                }
                <ListItemText
                  id={labelId}
                  primary={supplier[0].padStart(5, "0") + ":" + supplier[1]}
                />
              </ListItem>
            );
          })}
        </List>
      </div>
    </FormControl>
  );
}
